import { BuilderComponentState } from '@builder.io/react/dist/types/src/components/builder-component.component';
import React, { FC, useCallback, useState } from 'react';

import ArticleGridV2, { tabletTemplate } from '@/components/article-grid-v2/article-grid-v2';

import styles from './roomstay-blog-case-studies.module.scss';
import type { Article } from '@/types/article';

export interface SSProps {
    fixedArticles?: Article[];
    builderState?: BuilderComponentState;
    currentRow?: number;
    defaultOffset?: number;
    isLoading?: boolean;
}

export interface BuilderProps {
    offset?: number;
    cards?: {
        title?: string;
        image?: string;
        type?: string;
        tag?: string;
        url?: string;
    }[];
}

export interface Props extends BuilderProps, SSProps {}

export const CARDS_PER_PAGE = 6;

const RoomstayBlogCaseStudies: FC<Props> = ({ cards = [] }) => {
    const [currentPage, setCurrentPage] = useState<number>(1);

    const convertCardsToArticles = (cardsData: BuilderProps['cards']): any[] => {
        return cardsData?.map((card, index) => ({
            id: `card-${index}`,
            title: card.title || '',
            type: card.type || '',
            tag: card.tag || '',
            image: card.image || '',
            url: card.url || '/#',
        })) || [];
    };

    const articles = convertCardsToArticles(cards);
    const totalCards = cards.length;
    
    const cardsToShow = currentPage * CARDS_PER_PAGE;
    const currentArticles = articles.slice(0, cardsToShow);
    
    const hasMoreCards = totalCards > cardsToShow;

    const handleLoadMoreClick = useCallback(() => {
        if (!hasMoreCards) return;
        setCurrentPage(prev => prev + 1);
    }, [hasMoreCards]);

    if (!cards || cards.length === 0) {
        return null;
    }

    return (
        <div className={styles.root}>
            <ArticleGridV2
                articles={currentArticles}
                offsetArticle={cardsToShow}
                isLoadingMoreArticles={false}
                itemsPerPage={CARDS_PER_PAGE}
                onLoadMoreClick={handleLoadMoreClick}
                totalArticles={totalCards}
                templates={tabletTemplate}
            />
        </div>
    );
};

export default RoomstayBlogCaseStudies;
